<template>
  <div
    class="mt-1"
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <span style="font-size:20px; color: #fff;">ตารางสรุปจุดติดตั้งแต่ละสายทาง</span>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(wid)="data">
            <div>
              <b-link
                :to="{ path: `/wim-detail?wid=${data.item.id}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
            </div>
          </template>
          <template #cell(Info)="data">
            <b-button
              v-b-modal="'modalProject'"
              title="กดเพื่อดูเพิ่มเติม"
              size="sm"
              variant="outline"
              @click="$refs.pid2.InfoProject(data.item.id)"
            >
              <b-img
                src="@/assets/images/icons/info-icon.png"
                style="height: 40px; width: 40px;"
              />
            </b-button>
          </template>
          <template #cell(CCTV_Location)="data">
            {{ data.value }} จุด
          </template>
          <template #cell(CamTotal)="data">
            {{ data.value }} กล้อง
          </template>
          <template #cell(Cam_Online)="data">
            {{ data.value }} กล้อง
          </template>
          <template #cell(Cam_Offline)="data">
            {{ data.value }} กล้อง
          </template>
          <template #cell(Total_Vehicle)="data">
            {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
          </template>
        </b-table>
      </b-col>
    </b-row>
    <modal-Project ref="pid2" />
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink, BButton, BImg,
} from 'bootstrap-vue'
import axios from '@axios'
import modalProject from '@/views/modal/modalProject.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BLink,
    BButton,
    BImg,
    modalProject,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      fields: [
        {
          key: 'detail',
          label: 'จุดติดตั้ง',
          class: 'text-center',
        },
        {
          key: 'wid',
          label: 'รายละเอียด',
          class: 'text-center',
        },
        {
          key: 'Info',
          label: 'Project Info',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getMenuWIM()
    this.interval = setInterval(() => {
      this.getMenuWIM()
    }, 1000)
  },
  methods: {
    getMenuWIM() {
      axios
        .post('/getMarkerWIMSub', { DeptID: this.$route.query.DeptID, username: this.userData.username })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
  // .leaflet-container a.leaflet-popup-close-button {
  //   padding: 0 0 0 0
  // }
</style>
